// Module-level cache so thumbnail signed URLs survive filter-driven
// unmount/remount cycles and are shared across all components that display
// gallery images (GalleryPictureItem, FloorplanPinPreview, etc.).
// Entries are never evicted during a session — the URLs are scoped to the
// current authenticated session and the cache is small (one entry per image).
export const thumbnailUrlCache = new Map();
